import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'hero-slider';

/**
 * Class Foo.
 */
export class HeroSlider extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  currentIndex = 0;

  connectedCallback() {
    /** @type {NodeList} */
    this.items = this.querySelectorAll('.hero-slider__item');
    /** @type {NodeList} */
    this.bullets = this.querySelectorAll('.slider-bullet');
    /** @type {HTMLButtonElement} */
    this.prev = this.querySelector('.hero-slider-prev');
    /** @type {HTMLButtonElement} */
    this.next = this.querySelector('.hero-slider-next');

    this.prev.addEventListener('click', this.goPrev.bind(this));
    this.next.addEventListener('click', this.goNext.bind(this));

    for (const [index, bullet] of this.bullets.entries()) {
      bullet.addEventListener('click', () => {
        this.goTo(index);
      });
    }
  }

  /**
   * @returns {Number}
   */
  get indexMax() {
    return this.items.length - 1;
  }

  /**
   * goPrev
   */
  goPrev() {
    const newIndex = Math.max(0, this.currentIndex - 1);

    this.goTo(newIndex);
  }

  /**
   * geNext
   */
  goNext() {
    const newIndex = Math.min(this.currentIndex + 1, this.indexMax);
    this.goTo(newIndex);
  }

  /**
   * goTo
   * @param {Number} newIndex
   */
  goTo(newIndex) {
    // hide current
    this.items[this.currentIndex].classList.remove('is-active');
    this.bullets[this.currentIndex].classList.remove('is-active');

    // show new
    this.items[newIndex].classList.add('is-active');
    this.bullets[newIndex].classList.add('is-active');

    // update currentIndex
    this.currentIndex = newIndex;
  }
}

export default HeroSlider;
